<sbnb-apps-detail-page
  vendorCode="better-str"
  name="Better STR"
  logoTile="/assets/images/apps/better-str.jpg"
  builtBy="Better STR"
  builtByLink="https://betterstr.com"
  [categories]="['Guestbook']"
  [permissions]="[
    AppPermission.propertyListingRead,
    AppPermission.reservationRead,
    AppPermission.financialsRead,
    AppPermission.enrichmentGuidebookCode,
    AppPermission.calendarRead
  ]"
  email="info@betterstr.com"
  [helpArticles]="[
    {
      id: '10670731',
      title: 'Connect Hospitable with Better STR to create interactive guidebooks'
    }
  ]">
  <ng-container description>
    <p class="text-lg font-medium">🚀 FREE for at least 6 Months!</p>

    <p class="mt-4">
      Managing short-term rentals means juggling multiple bookings, guest messages, and property details. BetterSTR
      takes the hassle out of guest communication by integrating seamlessly with Hospitable, ensuring every guest gets
      the right information at the right time—without extra work from you.
    </p>

    <h3 class="text-lg font-medium mt-6 mb-2">How It Works:</h3>
    <ul class="list-disc pl-6 space-y-2">
      <li>Instantly syncs your Hospitable properties with BetterSTR's Guestbook system—no manual setup needed.</li>
      <li>
        Automatically fills in key reservation details, giving guests a personalized experience with unique property
        links.
      </li>
      <li>Sends trackable guestbook links through Hospitable's messaging system, keeping everything streamlined.</li>
      <li>Updates in real time—so your guest info is always accurate, even if bookings change.</li>
    </ul>

    <h3 class="text-lg font-medium mt-6 mb-2">Why BetterSTR?</h3>
    <ul class="list-disc pl-6 space-y-2">
      <li>
        <strong>Save Time:</strong>
        No need to manually send instructions—BetterSTR automates it.
      </li>
      <li>
        <strong>Reduce Questions:</strong>
        Guests have everything they need, from check-in details to house rules.
      </li>
      <li>
        <strong>Boost Satisfaction:</strong>
        A professional, interactive guestbook enhances their stay.
      </li>
    </ul>

    <p class="mt-4">
      Whether you manage one rental or a portfolio of properties, BetterSTR ensures smooth communication, happy guests,
      and fewer headaches.
    </p>

    <sbnb-image-carousel
      class="my-6"
      [images]="[
        '/assets/images/apps/better-str/1.png',
        '/assets/images/apps/better-str/2.png',
        '/assets/images/apps/better-str/3.png'
      ]"></sbnb-image-carousel>

    <div class="my-6" style="position: relative; padding-bottom: 62.5%; height: 0">
      <iframe
        src="https://www.youtube.com/embed/w9vRnZZpaY8?si=zzdZlu2cpPtOlacJ"
        frameborder="0"
        webkitallowfullscreen
        mozallowfullscreen
        allowfullscreen
        style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"></iframe>
    </div>
  </ng-container>
</sbnb-apps-detail-page>
